import React from 'react';

const CodeSpark = ({ color="#56B0BB", size = "16" }: { size?: string | number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_159_2458)">
        <g clip-path="url(#clip1_159_2458)">
          <path
            d="M12.3523 3.87872L13.1477 3.08338M3.647 12.1214L2.85167 12.9167M3.85834 3.66538L3.063 2.86938M12.141 12.3347L12.9363 13.1307M14.4997 7.99872H15.6243M0.375 7.99872H1.49967M5.99967 11.0001V7.00005M9.99967 9.00005V5.00005M3.99967 9.00005H7.99967M7.99967 7.00005H11.9997"
            stroke={color}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_159_2458">
          <rect width={size} height={size} fill={color} />
        </clipPath>
        <clipPath id="clip1_159_2458">
          <rect width={size} height={size} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CodeSpark;
